export function liveStreamUrl(baseUrl: string, ticket: string) {
  const url = new URL(baseUrl);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.pathname = "/api/v1/live/stream";
  url.search = "";
  url.searchParams.set("ticket", ticket);
  return url;
}
